import { render } from "./camera_popup_basic.vue?vue&type=template&id=28e43152&scoped=true"
import script from "./camera_popup_basic.vue?vue&type=script&lang=js"
export * from "./camera_popup_basic.vue?vue&type=script&lang=js"

import "./camera_popup_basic.vue?vue&type=style&index=0&id=28e43152&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e43152"]])

export default __exports__